angular
  .module('common.header', ['ui.bootstrap.typeahead', 'services.search', 'services.localizedMessages'])
  .controller('HeaderCtrl',["$templateCache", "$scope", "$rootScope", "$location", "searchService", "security", "user", "localizedMessages", function ($templateCache, $scope, $rootScope, $location, searchService, security, user, localizedMessages) {
    $scope.localizedMessages = localizedMessages;
    $scope.q = '';

    $scope.search = searchService.search;
    $scope.onSelect = searchService.onSelect;
    // console.log(user)
    $scope.isAuthenticated = function () {
      return !!user._id;
    };

    $scope.isAdmin = function () {
      return !!user && user.permissions &&user.permissions.is_admin;
    };

    $scope.isEditor = function () {
      return !!user && user.permissions &&user.permissions.is_editor;
    };

    $scope.logout = function () {
      return security.logout();
    };

    $scope.isActive = function (viewLocation) {
      return $location.path() === viewLocation;
    };

    $scope.resetRedis = function() {
      console.log('reset redis');
    }
  }]);



// WEBPACK FOOTER //
// ./client/src/app/common/header/header.js